module.exports = __webpack_public_path__ + "img/1F5E8.0a56aba0.svg";